import React, { useEffect } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import HomeContent from "../../components/Clearith/HomeContent";

const HomePage: React.FC = () => {
  useEffect(() => {
    document.title = "CLEARITH | Formation professionnelle certifiante";
  }, []);

  return (
    <div className="clearith-site">
      <div className="body_wrap o-clip">
        <Header />
        <main>
          <HomeContent />
        </main>
        <Footer />
        <Scrollbar />
      </div>
    </div>
  );
};

export default HomePage;
